import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onClickBind = this.onClick.bind(this)

        // UI
        this.$el = this.el

        // Data
        this.productID = this.getData('id')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$el.addEventListener('click', this.onClickBind)
    }

    unbindEvents() {
        this.$el.removeEventListener('click', this.onClickBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onClick() {
        this.addToCart()
    }

    ///////////////
    // Methods
    ///////////////
    addToCart() {
        const formData = {
            items: [
                {
                    id: this.productID,
                    quantity: 1,
                },
            ],
        };

        const item = {
            variant_id: this.productID,
            sku: this.getData('sku'),
            title: this.getData('title'),
            quantity: 1,
            price: this.getData('price') / 100,
            url: this.getData('url')
        };

        this.call('addToCart', { formData, openCart: true, item: item }, 'Cart');
    }
}
